module.exports = __webpack_public_path__ + "img/backpack-clock-table-icon.8170d4e9.svg";